<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :headerMenuTogglerVisible="false"
    :headerConfig="headerConfig"
    :roamType="'screen'"
    v-if="loaded"
  >
    <gc-barcode-parser @barcodeScanned="barcodeScanned" />
    <template #headerContent>
      <GcRoamHeaderContentDynamic
        :title="'Roam Picking'"
        :baseView="baseView"
        :primaryLabel="'Location Code ' + dataModel.Code"
        :secondaryLabel="dataModel.Location"
        :isXSmall="isXSmall"
        :createModeIsEditMode="true"
      />
    </template>

    <div v-if="loaded" class="roam-bin-movement">
      <dx-data-grid
        :data-source="getDataSource"
        :height="getHeight"
        :column-chooser="{ enabled: false }"
        :ref="'dx-data-grid-comp'"
        :repaint-changes-only="true"
        :show-borders="true"
        :two-way-binding-enabled="false"
      >
        <DxSearchPanel :visible="false" />
        <DxPaging :enabled="false" />
        <DxPager :visible="false" />
        <DxColumn data-field="BarCode" caption="Bar Code" />
        <DxColumn data-field="Bin" caption="Bin" />
        <DxColumn data-field="Variety" caption="Variety" />
        <DxColumn
          data-field="Status"
          caption=""
          cell-template="status-cell-template"
          width="50"
        />
        <template #status-cell-template="{ data: cell }">
          <div class="status-dot">
            <span
              class="queued"
              v-if="
                cell.data.Status == 'Queued' || cell.data.Status == 'Pending'
              "
            ></span>
            <span class="invalid" v-if="cell.data.Status == 'Invalid'"></span>
            <span
              class="completed"
              v-if="cell.data.Status == 'Completed'"
            ></span>
          </div>
        </template>
      </dx-data-grid>
    </div>
    <div
      class="view-card responsive-paddings save-btn-area"
      v-if="!saveDisabled.detail"
    >
      <DxButton
        :icon="undefined"
        :text="'Close'"
        type="default"
        width="100%"
        :disabled="saveDisabled.detail"
        @click="saveRoamTransaction"
      />
    </div>

    <GcPopup
      :popup-visible="detailPopUpFormVisible"
      :popup-title="detailPopUpConfig.option.title.text"
      :back-button-function="detailPopUpConfig.back.clickCallback"
      :fullScreen="true"
      :showTitle="detailPopUpConfig.option.title.visible"
      :saveButtonConfig="detailPopUpConfig.save"
      v-if="detailPopUpFormDataModel && detailPopUpFormVisible"
      :backButtonConfig="detailPopUpConfig.back"
    >
      <GcForm
        :formOptions="popUpFormOptions"
        :formItems="getDetailPopupFormItems"
        :isNormal="true"
        :data-model="detailPopUpFormDataModel"
        :formMode="baseView.mode"
        v-if="getDetailPopupFormItems"
        :formHeight="getFormHeight"
      ></GcForm>
    </GcPopup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import { RoamTransactionService } from "../../../_services/api/templates/roam-transactions.services";
import {
  DxColumn,
  DxDataGrid,
  DxSearchPanel,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";
// import { RoamBinMovementsService } from "../../../_services/api/roam/bin/roam-bin-movement.service";
import DataSource from "devextreme/data/data_source";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    DxColumn,
    DxDataGrid,
    DxSearchPanel,
    DxPaging,
    DxPager,
  },
  data() {
    return {
      loaded: false,
      allowOverPicking: false,
      backButtonRoute: "/roam-bin-movement",
      dataModel: undefined,
      validationSummary: [],
      setLoading: false,
      saveDisabled: {
        header: true,
        detail: true,
        line: false,
        save: false,
      },
      productsList: [],
      detailPopUpData: {
        EnableSave: false,
      },
      detailPopUpFormVisible: false,
      detailPopUpFormDataModel: {
        BarCodeValue: undefined,
        Location: undefined,
        LocationCode: undefined,
      },
      viewPoints: [{ menuText: "Details", value: 0, type: "details" }],
      popUpFormOptions: {
        gcLabelLocation: "left",
      },
      QueuedLookUpID: undefined,
    };
  },
  created() {
    this.$store.dispatch("roamBinMovement/clearStore");
    this.loaded = false;
    this.showLoading(true);
    this.getBinLocation();

    // setTimeout(() => {
    //   let test = [
    //     "235401797FGFF",
    //     "234403096FUIF",
    //     "224400218FUIF",
    //     "224000425HZWF",
    //     "221671431GY9F",
    //     "221115969GXRF",
    //     "235402195FGFF",
    //     "235400781FGHF",
    //     "234001036FS4F",
    //     "221672633GY5F",
    //   ];

    //   test.forEach((element, index) => {
    //     setTimeout(() => {
    //       this.barcodeScanned(element);
    //     }, 500 * index);
    //   });
    // }, 3000);
  },
  methods: {
    saveRoamTransaction() {
      clearInterval(this.QueuedLookUpID);
      this.setIgnoreRouteChangeConfirmation();
      this.$router
        .push({
          path: "/roam-bin-movement",
        })
        .then(() => {
          this.$store.dispatch("roamBinMovement/clearStore");
        });
    },
    async barcodeScanned(barcode) {
      if (this.userAcknowledgedInvalidBarcode === false) {
        return;
      }
      // barcode = "19254797fglf";
      if (barcode) {
        this.detailPopUpFormDataModel.BarCodeValue = undefined;
        // eslint-disable-next-line no-console
        console.log("barcode", barcode);
        let index = this.dataSourceStore._array.findIndex(
          (x) => x.BarCode == barcode
        );
        if (index == -1) {
          this.$store.dispatch("roamBinMovement/insertItem", {
            BarCode: barcode,
            Status: "Queued",
            LocationID: this.dataModel.Code,
          });
        }
      }
    },
    playBeep() {
      // the audio file needs to be created so that it can be queued and played
      // otherwise if we use a global audio file, it will not play if it is already playing
      let barcodeScannerAudio = new Audio("/barcode-scanner-sound.mp3");
      barcodeScannerAudio.play();
    },
    // async saveNewBinLocationData(data, barcode) {
    //   await RoamBinMovementsService.saveNew({
    //     BinCardNo: data.CardNumber,
    //     SeasonCode: data.SeasonYear,
    //     LocationID: this.dataModel.Code,
    //   })
    //     .then(() => {
    //       this.detailPopUpFormDataModel.BarCodeValue = undefined;
    //       this.saveDisabled.detail = false;

    //       this.$store.dispatch("roamBinMovement/updateItem", {
    //         Bin: data.CardNumber,
    //         Variety: data.ProdCat1,
    //         BarCode: barcode,
    //         Status: "Completed",
    //       });

    //       this.dataSourceStore.load();

    //       let dataGrid = this.$refs["dx-data-grid-comp"].instance;
    //       if (dataGrid) dataGrid.refresh(true);
    //       this.playBeep();
    //     })
    //     .catch((err) => {
    //       this.detailPopUpFormDataModel.BarCodeValue = undefined;
    //       // eslint-disable-next-line no-console
    //       this.displayServerError(err, "Save Failed");
    //     });
    // },
    getBinLocation() {
      RoamTransactionService.getByCode(
        "BinLocation",
        `Code eq '${this.baseView.id}'`
      )
        .then(async (res) => {
          this.dataModel = res.data.value[0];
          this.dataModel["SaveOption"] = undefined;

          this.detailPopUpFormDataModel.LocationCode = this.dataModel.Code;
          this.detailPopUpFormDataModel.Location = this.dataModel.Location;

          this.showLoading(false);
          this.loaded = true;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err) this.displayServerError(err, "Request Failed");
          this.showLoading(false);
          this.loaded = true;
        });
    },
    backButtonFunction() {
      clearInterval(this.QueuedLookUpID);
      this.$router
        .push({
          path: "/roam-bin-movement",
        })
        .then(() => {
          this.$store.dispatch("roamBinMovement/clearStore");
        });
    },

    onClickAddNew() {
      this.detailPopUpData.EnableSave = false;
      this.detailPopUpFormVisible = !this.detailPopUpFormVisible;
    },
    detailPopUpSaveCallBack() {
      // console.log('detailPopUpSaveCallBack ', data);
      this.detailPopUpFormVisible = false;
      this.barcodeScanned(this.detailPopUpFormDataModel.BarCodeValue);
    },
    async detailPopUpBackButtonClick() {
      let confirmLeaving = await this.$confirm(
        "Are you sure you want to cancel?",
        "Cancel"
      );

      if (confirmLeaving) {
        this.detailPopUpFormVisible = false;
      }
    },
    async detailsSalesUMPickedQtyValueChange() {
      this.saveDisabled.detail = false;
      this.saveDisabled.line = true;
      this.detailPopUpData.EnableSave = true;
    },
    refreshCallBack(error) {
      if (this.$refs["dx-data-grid-comp"]) {
        let dataGrid = this.$refs["dx-data-grid-comp"].instance;
        if (dataGrid) dataGrid.refresh(true);
      }

      if (error) {
        if (error.type == "server") {
          this.displayServerError(error.err, "Save Failed");
        } else {
          this.$alert(error.err, "Error");
        }
      } else {
        this.detailPopUpFormDataModel.BarCodeValue = undefined;
        this.saveDisabled.detail = false;
        this.playBeep();
      }
    },
  },
  computed: {
    ...mapGetters({
      dataSourceStore: "roamBinMovement/getDataSource",
      getDataLength: "roamBinMovement/getDataLength",
    }),
    getFormHeight() {
      return window.innerHeight - 120;
    },
    getDetailPopupFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "LocationCode",
              label: {
                text: "Location Code",
              },
              editorType: "dxTextBox",
              editorOptions: {
                readOnly: true,
              },
            },
            {
              dataField: "BarCodeValue",
              label: {
                text: "Bar Code",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
                onValueChanged: async (e) => {
                  this.detailsSalesUMPickedQtyValueChange(e);
                },
              },
            },
          ],
        },
      ];
    },
    detailPopUpConfig() {
      return {
        save: {
          text: "SAVE",
          clickCallback: () => {
            this.detailPopUpSaveCallBack();
          },
          disabled: !this.detailPopUpData.EnableSave,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.detailPopUpBackButtonClick();
          },
        },
        option: {
          title: {
            text: "NONE",
            visible: false,
          },
        },
      };
    },
    getPrimaryLabel() {
      return "Location Code " + this.dataModel.Code;
    },
    getHeight() {
      return this.gridHeight - (!this.saveDisabled.detail ? 75 : 0);
    },
    getDataSource() {
      //   return this.dataSourceStore._array;
      return new DataSource({
        store: this.dataSourceStore._array,
        reshapeOnPush: true,
      });
    },
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({
      primaryLabelFromStore: "transactionTemplate/getPrimaryLabel",
    }),
    ...mapGetters({
      secondaryLabelFromStore: "transactionTemplate/getSecondaryLabel",
    }),
    ...mapGetters({
      tertiaryLabelFromStore: "transactionTemplate/getTertiaryLabel",
    }),
    ...mapGetters({
      headerKey: "transactionTemplate/getHeaderKey",
    }),
    headerConfig() {
      return {
        options: {
          multiViewSelect: false,
          addNew: true,
          viewPoints: this.viewPoints,
        },
        data: {
          addNew: {
            icon: "plus",
            type: "normal",
            class: "class-a1",
            cssClass: "class-a2",
            userAcknowledgedInvalidBarcode: true,
            onClick: () => {
              this.onClickAddNew();
            },
          },
        },
      };
    },
  },
  watch: {
    getDataLength(value) {
      if (value > 0) {
        if (!this.QueuedLookUpID) {
          this.QueuedLookUpID = setInterval(() => {
            this.$store.dispatch(
              "roamBinMovement/processQueuedRequests",
              this.refreshCallBack
            );
          }, 500);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.roam-bin-movement {
  .status-dot {
    > span {
      height: 25px;
      width: 25px;
      border-radius: 50%;
      display: inline-block;
    }
    .queued {
      background-color: #e8da1a;
    }
    .invalid {
      background-color: #ff0000;
    }
    .completed {
      background-color: #38cb13;
    }
  }
}
</style>